export default __webpack_public_path__ + "static/media/maxiv.3e835210.png";